import * as React from "react";
import {
  SignalCellularConnectedNoInternet0Bar as IconConnecting,
  SignalCellular4Bar as IconConnected,
  SignalCellularConnectedNoInternet4Bar as IconDisconnected,
} from "@material-ui/icons";
import {
  makeStyles,
  createStyles,
  Theme,
  Popover,
  Typography,
  IconButton,
} from "@material-ui/core";
import { MessageState } from "lib/api";
import { useMessagesClient } from "lib/store";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1),
    },
    popover: {
      pointerEvents: "none",
    },
    paper: {
      padding: theme.spacing(1),
    },
  })
);

const icons: { [k in MessageState]: JSX.Element } = {
  [MessageState.Connecting]: <IconConnecting />,
  [MessageState.Connected]: <IconConnected />,
  [MessageState.Disconnected]: <IconDisconnected />,
};

const NetworkState: React.FunctionComponent = () => {
  const [state, setState] = React.useState<MessageState>(
    MessageState.Connecting
  );
  const [error, setError] = React.useState<string | undefined>(undefined);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const msg = useMessagesClient();
  const classes = useStyles();

  React.useEffect(() => {
    msg.onMessageStateChange((state) => {
      setState(state);
      if (state === MessageState.Disconnected) {
        setError("Disconnected");
      }
    });
    return () => {
      msg.onMessageStateChange(undefined);
    };
  }, [msg]);

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.root}>
      <IconButton
        color="inherit"
        aria-owns={Boolean(anchorEl) ? "networkstate-popover" : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {icons[state]}
      </IconButton>
      {error && (
        <Popover
          id="networkstate-popover"
          className={classes.popover}
          classes={{
            paper: classes.paper,
          }}
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <Typography>{error}</Typography>
        </Popover>
      )}
    </div>
  );
};

export default NetworkState;
